exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".vp-signature{text-align:right;height:100%}.vp-signature .dotted-line{height:2px;border:1px dashed #b3b3b3;margin:0 20px;position:absolute;left:0;right:0;bottom:30%;pointer-events:none}.vp-signature .vp-signature-clear{text-transform:uppercase}.vp-signature .signatureBorder{border:8px solid #d7d7d7;background-color:#d7d7d7}.vp-signature .m-signature-pad{width:100%;height:100%;background-color:#fff;border-radius:5px}.vp-signature .m-signature-pad--body,.vp-signature canvas{width:100%;height:100%}.vp-signature canvas{cursor:crosshair}", ""]);

// exports
